export const EquationCardVariableCondition = () =>{
    return(
        <div className="container">
            <p>数式エディタのカードのカードパラメータの条件をしてしています</p>
            <img src={`${process.env.PUBLIC_URL}/equation_card_variable_condition.png`}></img>
            <p>図の例ではレベルが4以上、攻撃力が3以上の条件を指定しています</p>
            </div>
    )
}
